<template>
	<v-chip pill class="v-chip--active" v-bind="$attrs" v-on="$listeners" label outlined :color="datos.color">
		<v-icon :small="'small' in $attrs" left>{{ datos.icon }}</v-icon>
		<span>{{ value }}</span>
		<slot/>
	</v-chip>
</template>

<script>
import { getSituacionIcon } from "@/utils/index.js";

export default {
	props: { value: String },
	computed: {
		datos() {
			return getSituacionIcon(this.value) || {};
		},
	},
};
</script>

<style>

</style>